<script lang="ts" setup>
import ProProfileService from '@/core/conversations/pro-profile/pro-profile.service';
import { ErrorService } from '@/core/shared/errors/error.service';
import DownloadIcon from '@/assets/svg/conversations/DownloadIcon.svg?component';
import { SnackbarService } from '@/core/shared/snackbar/snackbar.service';
import { TrackingActionName } from '@/core/shared/tracking/tracking-actions';
import TrackingService from '@/core/shared/tracking/tracking.service';
import { toPdfFileName } from '@/utils/strings/pdf-file-name.util';

const proProfileService = new ProProfileService();

const downloadProfile = async () => {
  try {
    if (!(proProfileService.selectedProApplication && proProfileService.selectedProProfile)) return;
    const { nameFirst, nameLast } = proProfileService.selectedProProfile;
    const { id: applicationId } = proProfileService.selectedProApplication;

    const pdfFile = await proProfileService.downloadProfilePdf(applicationId);
    const linkSource = `data:application/pdf;base64,${pdfFile}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = toPdfFileName(`${nameFirst}_${nameLast}_profile`);
    downloadLink.click();
    TrackingService.trackAction(TrackingActionName.PROFILE_DOWNLOADED);
  } catch (error) {
    ErrorService.captureException(error);
    SnackbarService.critical('Failed to download profile');
  }
};
</script>

<template>
  <div
    class="relative grid h-7 w-7 cursor-pointer place-content-center rounded-md text-shade-900 hover:bg-tint-40 active:bg-tint-60"
    @click="downloadProfile"
  >
    <DownloadIcon class="pointer-events-none" />
    <v-tooltip activator="parent" location="bottom" content-class="application-picker__tooltip">
      Download profile
    </v-tooltip>
  </div>
</template>
